import { render, staticRenderFns } from "./WizardStepJobMatchJobGoal.vue?vue&type=template&id=c8835db2&scoped=true&lang=pug&"
import script from "./WizardStepJobMatchJobGoal.vue?vue&type=script&lang=ts&"
export * from "./WizardStepJobMatchJobGoal.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStepJobMatchJobGoal.vue?vue&type=style&index=0&id=c8835db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8835db2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8835db2')) {
      api.createRecord('c8835db2', component.options)
    } else {
      api.reload('c8835db2', component.options)
    }
    module.hot.accept("./WizardStepJobMatchJobGoal.vue?vue&type=template&id=c8835db2&scoped=true&lang=pug&", function () {
      api.rerender('c8835db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/jobmatch-steps/WizardStepJobMatchJobGoal.vue"
export default component.exports